import { render, staticRenderFns } from "./studios.vue?vue&type=template&id=08669cdc&scoped=true"
import script from "./studios.vue?vue&type=script&lang=js"
export * from "./studios.vue?vue&type=script&lang=js"
import style0 from "./studios.vue?vue&type=style&index=0&id=08669cdc&prod&scoped=true&lang=scss"
import style1 from "./studios.vue?vue&type=style&index=1&id=08669cdc&prod&scoped=true&lang=css"
import style2 from "./studios.vue?vue&type=style&index=2&id=08669cdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08669cdc",
  null
  
)

export default component.exports